import { useState } from "react";
import { toast } from "sonner";
import { http, errMsg } from "../lib/api";

export default function JoinReaders({ endpoint, authorName, testid = "join-readers" }) {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await http.post(endpoint, { email, name });
      setDone(true);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <div className="border border-[#121210] p-8 bg-[#F6F2EA]" data-testid={`${testid}-success`}>
        <p className="font-hand text-3xl text-[#C84B31]">You're on the list.</p>
        <p className="mt-2 text-[#5C584E]">{authorName} will reach you directly when there's news.</p>
      </div>
    );
  }
  return (
    <form onSubmit={submit} className="border border-[#121210] p-6 sm:p-8 bg-[#F6F2EA]" data-testid={`${testid}-form`}>
      <p className="label-mono">Readers' list</p>
      <h3 className="font-display text-2xl sm:text-3xl mt-2">Join {authorName}'s readers</h3>
      <p className="text-[#5C584E] mt-2 text-[0.95rem]">New books, early chapters and launch news, straight from the author. No spam, no middlemen.</p>
      <div className="mt-5 grid sm:grid-cols-[1fr_1.4fr_auto] gap-3">
        <input className="input-paper" placeholder="First name" value={name} onChange={(e) => setName(e.target.value)} data-testid={`${testid}-name-input`} />
        <input className="input-paper" type="email" required placeholder="you@email.com" value={email} onChange={(e) => setEmail(e.target.value)} data-testid={`${testid}-email-input`} />
        <button className="btn-accent bg-[#C84B31] text-white px-6 py-3 font-type text-xs uppercase tracking-widest shadow-[3px_3px_0_0_#121210] hover:bg-[#A93A22] transition-colors disabled:opacity-50" disabled={busy} data-testid={`${testid}-submit-button`}>
          {busy ? "Joining…" : "Join"}
        </button>
      </div>
    </form>
  );
}
